export enum RolesEnum {
    author = "Author",
    contentEditor = "ContentEditor",
    karnovEditor = "KarnovEditor",
    overrideAuthor = "OverrideAuthor",
}